/* CIELO redesign (Rasm Lab) */
(function () {
  var SIZE_RE = /size|مقاس/i;

  function mainProductInfo() {
    return document.querySelector('product-info[id^="MainProduct-"]:not([id*="quickadd"])');
  }

  function submitButton(scope) {
    return scope ? scope.querySelector('.product-form__submit') : null;
  }

  function sizeFieldset(scope) {
    if (!scope) return null;
    var sets = scope.querySelectorAll('variant-selects fieldset');
    for (var i = 0; i < sets.length; i++) {
      var legend = sets[i].querySelector('legend');
      if (legend && SIZE_RE.test(legend.textContent)) return sets[i];
    }
    return null;
  }

  /* 1. Product page: no size is pre-selected, so customers pick their size on purpose */
  function initNoPreselect(scope) {
    if (!scope || scope.dataset.cieloNoPreselect) return;
    scope.dataset.cieloNoPreselect = '1';
    if (new URLSearchParams(window.location.search).has('variant')) return;

    var fieldset = sizeFieldset(scope);
    if (!fieldset) return;
    var inputs = fieldset.querySelectorAll('input[type="radio"]');
    if (inputs.length < 2) return;

    var button = submitButton(scope);
    if (!button) return;
    var label = button.querySelector('span');

    inputs.forEach(function (input) {
      input.checked = false;
    });
    scope.dataset.cieloNeedsSize = '1';
    button.disabled = true;
    if (label) label.textContent = button.dataset.cieloSelectLabel || 'Select a size';

    fieldset.addEventListener(
      'change',
      function () {
        delete scope.dataset.cieloNeedsSize;
      },
      { once: true }
    );
  }

  /* Size helper under the sizes, and the chosen size on the Add to cart button ("Add to cart · 42EU") */
  function sizeHelperText(scope) {
    var fieldset = sizeFieldset(scope);
    if (!fieldset) return '';
    var checked = scope.dataset.cieloNeedsSize ? null : fieldset.querySelector('input[type="radio"]:checked');
    var soldOut = fieldset.querySelectorAll('input[type="radio"].disabled').length > 0;
    if (!checked) return 'Select your size' + (soldOut ? ' · crossed-out sizes are sold out' : '');
    var label = fieldset.querySelector('label[for="' + checked.id + '"]');
    var name = label ? label.childNodes[0].textContent.trim() : checked.value;
    return checked.classList.contains('disabled') ? name + ' is sold out · pick another size' : name + ' selected';
  }
  function initSizeHelper(scope) {
    if (!scope || scope.dataset.cieloHelper) return;
    scope.dataset.cieloHelper = '1';
    var helper = scope.querySelector('.cielo-size-helper');
    var update = function () {
      var fieldset = sizeFieldset(scope);
      var button = submitButton(scope);
      var checked = fieldset && !scope.dataset.cieloNeedsSize && fieldset.querySelector('input[type="radio"]:checked');
      var label = checked && fieldset.querySelector('label[for="' + checked.id + '"]');
      var text = button && button.querySelector('span');
      if (text) {
        if (label) text.dataset.cieloSize = label.childNodes[0].textContent.trim();
        else delete text.dataset.cieloSize;
      }
      if (helper) helper.textContent = sizeHelperText(scope);
    };
    scope.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches('variant-selects input[type="radio"]')) {
        delete scope.dataset.cieloNeedsSize;
        update();
      }
    });
    update();
  }

  /* 2. Sticky add to cart on mobile, mirrors the main button */
  if (!customElements.get('cielo-sticky-atc')) {
    customElements.define(
      'cielo-sticky-atc',
      class extends HTMLElement {
        connectedCallback() {
          var self = this;
          this.info = mainProductInfo();
          this.main = submitButton(this.info);
          this.button = this.querySelector('.cielo-sticky-atc__button');
          if (!this.main || !this.button) return;
          this.hidden = false;

          this.sync = function () {
            var needsSize = self.info && self.info.dataset.cieloNeedsSize;
            var mainLabel = self.main.querySelector('span');
            self.button.textContent = needsSize
              ? self.dataset.selectLabel
              : (mainLabel ? mainLabel.textContent.trim() : self.dataset.addLabel);
            self.button.disabled = !needsSize && self.main.disabled;
          };
          new MutationObserver(this.sync).observe(this.info, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: ['disabled', 'data-cielo-needs-size'],
          });
          this.sync();

          document.body.classList.add('cielo-has-sticky-atc');
          new IntersectionObserver(function (entries) {
            self.classList.toggle('is-visible', !entries[0].isIntersecting);
          }).observe(this.main);

          this.button.addEventListener('click', function () {
            var main = submitButton(self.info);
            if (self.info.dataset.cieloNeedsSize || !main) {
              var fs = sizeFieldset(self.info);
              (fs || self.info).scrollIntoView({ behavior: 'smooth', block: 'center' });
              return;
            }
            main.click();
          });
        }
      }
    );
  }

  /* 3. Load more on collection pages */
  function initLoadMore(root) {
    var box = root.querySelector('.cielo-load-more');
    if (!box || box.dataset.ready) return;
    box.dataset.ready = '1';
    var grid = root.querySelector('#product-grid');
    var button = box.querySelector('button');
    var pagination = root.querySelector('.cielo-pagination');
    if (!grid || !button) return;
    if (pagination) pagination.hidden = true;
    box.hidden = false;

    button.addEventListener('click', function () {
      var next = box.dataset.next;
      if (!next) return;
      button.disabled = true;
      button.classList.add('loading');
      fetch(next)
        .then(function (r) {
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          doc.querySelectorAll('#product-grid > li').forEach(function (li) {
            li.classList.remove('scroll-trigger', 'animate--slide-in');
            grid.appendChild(li);
          });
          var nextBox = doc.querySelector('.cielo-load-more');
          box.dataset.next = nextBox ? nextBox.dataset.next || '' : '';
          var shown = grid.querySelectorAll('li.grid__item:not(.cielo-soldout-divider)').length;
          var total = Number(box.dataset.total || 0);
          var count = box.querySelector('.cielo-load-more__count');
          var fill = box.querySelector('.cielo-load-more__fill');
          if (count) count.textContent = count.dataset.template.replace('[shown]', shown).replace('[total]', total);
          if (fill && total) fill.style.width = Math.min(100, Math.round((shown / total) * 100)) + '%';
          if (!box.dataset.next) button.hidden = true;
        })
        .catch(function () {
          if (pagination) pagination.hidden = false;
        })
        .finally(function () {
          button.disabled = false;
          button.classList.remove('loading');
        });
    });
  }

  /* Product gallery: "1 / N" on the photo, kept in step with swipes and thumbnails */
  function initMediaCount(scope) {
    var viewer = scope && scope.querySelector('slider-component[id^="GalleryViewer"]');
    if (!viewer || viewer.querySelector('.cielo-media-count')) return;
    var total = viewer.querySelectorAll('.product__media-item').length;
    if (total < 2) return;
    var badge = document.createElement('span');
    badge.className = 'cielo-media-count';
    badge.setAttribute('aria-hidden', 'true');
    badge.textContent = '1 / ' + total;
    viewer.appendChild(badge);
    viewer.addEventListener('slideChanged', function (e) {
      if (e.detail && e.detail.currentPage) badge.textContent = e.detail.currentPage + ' / ' + total;
    });
  }

  function init() {
    initNoPreselect(mainProductInfo());
    initSizeHelper(mainProductInfo());
    initMediaCount(mainProductInfo());
    document.querySelectorAll('[id^="ProductGridContainer"]').forEach(function (el) {
      initLoadMore(el.closest('.shopify-section') || document);
    });
    var grid = document.getElementById('ProductGridContainer');
    if (grid) initLoadMore(grid.parentElement || document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Quick add windows load their own product form later: no size pre-selected there either */
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        var forms = node.matches && node.matches('product-info') ? [node] : node.querySelectorAll ? node.querySelectorAll('product-info') : [];
        forms.forEach(function (info) {
          if (!info.closest('quick-add-modal')) return;
          initNoPreselect(info);
          initSizeHelper(info);
          watchSwatches(info);
        });
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  /* Filter drawer: Dawn closes every group when the drawer closes, so reopen them all each time */
  document.addEventListener(
    'toggle',
    function (e) {
      var d = e.target;
      if (!d.matches || !d.matches('.mobile-facets__disclosure') || !d.open) return;
      d.querySelectorAll('.cielo-flat-facets details.mobile-facets__details').forEach(function (inner) {
        inner.setAttribute('open', '');
      });
    },
    true
  );

  /* Home videos: load the compressed file only when it comes near the screen */
  function initLazyVideos() {
    var videos = document.querySelectorAll('video.cielo-lazy-video:not([data-ready])');
    if (!videos.length) return;
    var conn = navigator.connection || {};
    var lite = conn.saveData || /(^|-)2g|3g/.test(conn.effectiveType || '');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var start = function (v) {
      v.dataset.ready = '1';
      if (v.dataset.poster) v.poster = v.dataset.poster;
      v.src = (lite && v.dataset.srcLite) || v.dataset.src;
      if (reduce) return syncVideoToggle(v);
      v.play().catch(function () {
        syncVideoToggle(v);
      });
    };
    if (!('IntersectionObserver' in window)) return videos.forEach(start);
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.unobserve(e.target);
          start(e.target);
        });
      },
      { rootMargin: '400px 0px' }
    );
    videos.forEach(function (v) {
      io.observe(v);
    });
  }
  initLazyVideos();

  /* Videos row (sections/cielo-video-row.liquid): pause/play button, and pause while off screen */
  function syncVideoToggle(v) {
    var frame = v.closest('.cielo-videos__frame');
    if (!frame) return;
    var btn = frame.querySelector('[data-cielo-video-toggle]');
    frame.classList.toggle('is-paused', v.paused);
    if (btn) btn.setAttribute('aria-label', v.paused ? 'Play video' : 'Pause video');
  }
  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  document.addEventListener('visibilitychange', function () {
    if (document.hidden || reduceMotion()) return;
    document.querySelectorAll('.cielo-videos video[data-ready]').forEach(function (v) {
      var r = v.getBoundingClientRect();
      if (v.paused && !v.dataset.userPaused && r.bottom > 0 && r.top < window.innerHeight) v.play().catch(function () {});
    });
  });
  function initVideoRow() {
    document.querySelectorAll('.cielo-videos video:not([data-row-ready])').forEach(function (v) {
      v.setAttribute('data-row-ready', '');
      v.addEventListener('play', function () {
        syncVideoToggle(v);
      });
      v.addEventListener('pause', function () {
        syncVideoToggle(v);
      });
      if (!('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!v.dataset.ready) return;
          if (!e.isIntersecting && !v.paused) {
            v.dataset.autoPaused = '1';
            v.pause();
          } else if (e.isIntersecting && v.paused && !v.dataset.userPaused && !reduceMotion()) {
            // back on screen: resume, also after the browser paused it while the tab was hidden
            delete v.dataset.autoPaused;
            v.play().catch(function () {});
          }
        });
      }).observe(v);
    });
  }
  initVideoRow();
  document.addEventListener('shopify:section:load', function () {
    initLazyVideos();
    initVideoRow();
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cielo-video-toggle]');
    if (!btn) return;
    var v = btn.closest('.cielo-videos__frame').querySelector('video');
    if (!v) return;
    if (!v.dataset.ready && v.dataset.src) {
      v.dataset.ready = '1';
      if (v.dataset.poster) v.poster = v.dataset.poster;
      v.src = v.dataset.src;
    }
    if (v.paused) {
      delete v.dataset.userPaused;
      v.play().catch(function () {});
    } else {
      v.dataset.userPaused = '1';
      v.pause();
    }
  });

  /* Colour swatches (FD Product Groups app) are labelled with the full product title: show only the colour */
  function colourName(title) {
    /* "Line - Colour", "Line- Colour" or "Line -Colour": keep the part after the last spaced dash */
    var parts = title.trim().split(/\s+[-\u2013]\s*|\s*[-\u2013]\s+/);
    if (parts.length < 2) return title.trim();
    return parts[parts.length - 1]
      .trim()
      .toLowerCase()
      .replace(/(^|\s)\S/g, function (c) {
        return c.toUpperCase();
      });
  }
  function tidySwatches(root) {
    root.querySelectorAll('.fd-options-swatch label > div:first-child').forEach(function (el) {
      var m = el.textContent.match(/^([^:]+):\s*(.+)$/);
      if (!m) return;
      var raw = m[1].trim();
      var key = raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase() + ':';
      var value = colourName(m[2]);
      var keyEl = el.querySelector('.cielo-swatch-key');
      if (keyEl && keyEl.textContent === key && el.lastChild && el.lastChild.textContent === ' ' + value) return;
      /* "Color:" in bold, then the colour name (design) */
      el.textContent = '';
      var strong = document.createElement('span');
      strong.className = 'cielo-swatch-key';
      strong.textContent = key;
      el.appendChild(strong);
      el.appendChild(document.createTextNode(' ' + value));
    });
    var info = root.closest ? root.closest('product-info') : null;
    var current = info && info.dataset.url ? info.dataset.url : window.location.pathname;
    root.querySelectorAll('.fd-options-swatch__options a').forEach(function (a) {
      var isCurrent = false;
      try {
        isCurrent = new URL(a.href, window.location.origin).pathname === new URL(current, window.location.origin).pathname;
      } catch (err) {}
      if (a.classList.contains('cielo-current') !== isCurrent) a.classList.toggle('cielo-current', isCurrent);
      if (isCurrent && a.getAttribute('aria-current') !== 'true') {
        a.setAttribute('aria-current', 'true');
        var row = a.parentElement;
        if (row && row.scrollWidth > row.clientWidth) row.scrollLeft = Math.max(0, a.offsetLeft - row.offsetLeft - (row.clientWidth - a.offsetWidth) / 2);
      }
      var thumb = a.querySelector('img');
      if (thumb && thumb.getAttribute('alt') !== '') thumb.setAttribute('alt', '');
      var tip = a.querySelector('.fd-floating-tooltip');
      if (!tip || !tip.textContent.trim()) return;
      var want = colourName(tip.textContent);
      if (tip.textContent !== want) tip.textContent = want;
      if (a.getAttribute('aria-label') !== want) a.setAttribute('aria-label', want);
    });
  }
  function watchSwatches(root) {
    root.querySelectorAll('.fd-app-block:not([data-cielo-watched])').forEach(function (block) {
      block.dataset.cieloWatched = '1';
      tidySwatches(block);
      new MutationObserver(function () {
        tidySwatches(block);
      }).observe(block, { childList: true, subtree: true, characterData: true });
    });
  }
  watchSwatches(document);

  /* Quick add: Dawn re-focuses the chosen size after each change, which scrolls the window's fixed frame
     and leaves a white gap. The frame never needs to scroll, so pin it. */
  document.addEventListener(
    'scroll',
    function (e) {
      var el = e.target;
      if (!el.classList || !el.classList.contains('quick-add-modal__content') || el.scrollTop === 0) return;
      if (getComputedStyle(el).overflowY !== 'auto') el.scrollTop = 0;
    },
    true
  );

  /* Add a piece without leaving the page: cart "Complete your look", home lookbook rows, product Shop the look */
  function pickedVariant(button) {
    if (button.dataset.variantId) return { id: button.dataset.variantId };
    var item = button.closest('.cielo-recs__item, .cielo-look__item');
    var select = item && item.querySelector('.cielo-recs__select');
    if (select) return { id: select.value, field: select };
    var sizes = item && item.querySelector('.cielo-look__sizes');
    var checked = sizes && sizes.querySelector('input:checked');
    return { id: checked ? checked.value : '', field: sizes };
  }
  function addPiece(button) {
    var picked = pickedVariant(button);
    var item = button.closest('.cielo-recs__item, .cielo-look__item');
    var msg = item && item.querySelector('.cielo-look__msg');
    if (!picked.id) {
      if (picked.field) {
        picked.field.classList.add('is-missing');
        var first = picked.field.matches('select') ? picked.field : picked.field.querySelector('input');
        if (first) first.focus();
      }
      if (msg) msg.textContent = 'Pick a size first';
      return;
    }
    var drawer = document.querySelector('cart-drawer');
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;
    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(picked.id), quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (state) {
        if (state.status || !state.sections) throw new Error(state.description || state.message || 'Could not add');
        button.removeAttribute('aria-busy');
        button.disabled = false;
        if (msg) msg.textContent = 'Added to your bag';
        if (drawer && drawer.renderContents) {
          /* as Dawn's product form does: an empty bag drawer must drop its empty state before it opens */
          drawer.classList.remove('is-empty');
          drawer.renderContents(state);
        } else window.location.href = window.routes.cart_url;
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cielo-add', productVariantId: picked.id, cartData: state });
        }
      })
      .catch(function (err) {
        button.removeAttribute('aria-busy');
        button.disabled = false;
        if (msg) msg.textContent = err.message;
        console.error(err);
      });
  }
  document.addEventListener('click', function (e) {
    var button = e.target.closest && e.target.closest('.cielo-recs__add, .cielo-look__add');
    if (button) addPiece(button);
  });
  document.addEventListener('change', function (e) {
    var field = e.target.closest && e.target.closest('.cielo-recs__select, .cielo-look__sizes');
    if (field) field.classList.remove('is-missing');
  });

  /* Home lookbook: a pin points to its piece in the list */
  document.addEventListener('click', function (e) {
    var pin = e.target.closest && e.target.closest('.cielo-lookbook__pin');
    if (!pin) return;
    var row = document.getElementById(pin.dataset.target);
    if (!row) return;
    row.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    row.classList.add('is-highlight');
    setTimeout(function () {
      row.classList.remove('is-highlight');
    }, 1600);
    var control = row.querySelector('select:not([disabled]), .cielo-recs__add');
    if (control) control.focus({ preventScroll: true });
  });

  /* Footer menus open and close on phones */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest && e.target.closest('.cielo-footer-toggle');
    if (!toggle) return;
    var open = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    var list = document.getElementById(toggle.getAttribute('aria-controls'));
    if (list) list.classList.toggle('is-open', open);
  });

  /* Quick add: tapping another colour loads that colour in the same window instead of leaving the page */
  document.addEventListener(
    'click',
    function (e) {
      var swatch = e.target.closest && e.target.closest('quick-add-modal .fd-options-swatch__options a[href]');
      if (!swatch) return;
      var modal = swatch.closest('quick-add-modal');
      var content = modal && modal.modalContent;
      /* HTMLUpdateUtility is a top-level class in Dawn's global.js: reachable by name, not on window */
      if (!content || typeof modal.preprocessHTML !== 'function' || typeof HTMLUpdateUtility === 'undefined') return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (swatch.classList.contains('pg-product') && swatch.getAttribute('aria-current') === 'true') return;
      content.classList.add('cielo-swapping');
      fetch(swatch.href)
        .then(function (r) {
          return r.text();
        })
        .then(function (html) {
          var info = new DOMParser().parseFromString(html, 'text/html').querySelector('product-info');
          if (!info) throw new Error('No product form');
          modal.preprocessHTML(info);
          HTMLUpdateUtility.setInnerHTML(content, info.outerHTML);
          if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
        })
        .catch(function () {
          window.location.href = swatch.href;
        })
        .finally(function () {
          content.classList.remove('cielo-swapping');
        });
    },
    true
  );

  /* Hero banner with only a tall photo: on desktop the photo sits in the middle and each side continues the
     photo's own edge colours (top to bottom), so wall and floor carry on without a seam. Works for any photo. */
  function initHeroFill() {
    document.querySelectorAll('.cielo-hero__media[data-cielo-edge-fill]:not([data-filled])').forEach(function (media) {
      var img = media.querySelector('img');
      if (!img) return;
      media.dataset.filled = '1';
      var src;
      try {
        src = new URL(img.currentSrc || img.src, window.location.href);
        src.searchParams.set('width', '240');
      } catch (err) {
        return;
      }
      var probe = new Image();
      probe.crossOrigin = 'anonymous';
      probe.onload = function () {
        try {
          var canvas = document.createElement('canvas');
          canvas.width = probe.naturalWidth;
          canvas.height = probe.naturalHeight;
          var ctx = canvas.getContext('2d');
          ctx.drawImage(probe, 0, 0);
          var strip = Math.max(2, Math.round(canvas.width * 0.03));
          var stops = 60;
          var side = function (x0) {
            var out = [];
            for (var i = 0; i <= stops; i++) {
              var y = Math.min(canvas.height - 1, Math.round((i / stops) * (canvas.height - 1)));
              var d = ctx.getImageData(x0, y, strip, 1).data;
              var r = 0, g = 0, b = 0;
              for (var k = 0; k < d.length; k += 4) {
                r += d[k];
                g += d[k + 1];
                b += d[k + 2];
              }
              var n = d.length / 4;
              out.push('rgb(' + Math.round(r / n) + ',' + Math.round(g / n) + ',' + Math.round(b / n) + ') ' + ((i / stops) * 100).toFixed(1) + '%');
            }
            return 'linear-gradient(to bottom, ' + out.join(', ') + ')';
          };
          media.style.background =
            side(0) + ' left / 50% 100% no-repeat, ' + side(canvas.width - strip) + ' right / 50% 100% no-repeat';
        } catch (err) {
          /* image could not be read (another domain): keep the plain background */
        }
      };
      probe.src = src.toString();
    });
  }
  initHeroFill();
  document.addEventListener('shopify:section:load', initHeroFill);

  /* Moving strip on the home page: tap, click or Enter/Space pauses and restarts it */
  document.addEventListener('click', function (e) {
    var strip = e.target.closest && e.target.closest('.cielo-marquee');
    if (strip) strip.classList.toggle('is-paused');
  });
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.classList && e.target.classList.contains('cielo-marquee')) {
      e.preventDefault();
      e.target.classList.toggle('is-paused');
    }
  });

  /* Shop the look by tag: products that share a "look-" tag show each other (sections/cielo-product-look) */
  function initLookTags() {
    document.querySelectorAll('[data-look-tags]:not([data-look-done])').forEach(function (box) {
      box.setAttribute('data-look-done', '');
      var current = box.getAttribute('data-look-product');
      var limit = parseInt(box.getAttribute('data-look-limit'), 10) || 3;
      var tags = box.getAttribute('data-look-tags').split(',').filter(Boolean).slice(0, 3);
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      Promise.all(
        tags.map(function (tag) {
          return fetch(root + 'collections/all/' + encodeURIComponent(tag) + '?section_id=cielo-look-results')
            .then(function (r) {
              return r.ok ? r.text() : '';
            })
            .catch(function () {
              return '';
            });
        })
      ).then(function (pages) {
        var seen = {};
        seen[current] = true;
        var picked = [];
        pages.forEach(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var results = doc.querySelector('[data-cielo-look-results]');
          if (!results || results.getAttribute('data-filtered') !== 'true') return;
          results.querySelectorAll(':scope > .cielo-look__item').forEach(function (li) {
            var id = li.getAttribute('data-product-id');
            if (seen[id] || picked.length >= limit) return;
            seen[id] = true;
            picked.push(li);
          });
        });
        if (!picked.length) return;
        var list = box.querySelector('.cielo-look__list');
        var heading = box.querySelector('.cielo-look__heading');
        list.innerHTML = '';
        picked.forEach(function (li) {
          list.appendChild(document.importNode(li, true));
        });
        if (heading) heading.textContent = box.getAttribute('data-look-heading') || heading.textContent;
        box.hidden = false;
      });
    });
  }
  initLookTags();
  document.addEventListener('shopify:section:load', initLookTags);

  /* Instagram reel: load Instagram's embed script only when the reel is close to the screen */
  function initReels() {
    var frames = document.querySelectorAll('[data-cielo-reel]:not([data-ready])');
    if (!frames.length) return;
    var load = function () {
      if (window.instgrm && window.instgrm.Embeds) {
        window.instgrm.Embeds.process();
        return;
      }
      if (document.getElementById('cielo-instagram-embed')) return;
      var s = document.createElement('script');
      s.id = 'cielo-instagram-embed';
      s.async = true;
      s.src = 'https://www.instagram.com/embed.js';
      document.body.appendChild(s);
    };
    if (!('IntersectionObserver' in window)) return load();
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.setAttribute('data-ready', '');
          io.disconnect();
          load();
        });
      },
      { rootMargin: '600px 0px' }
    );
    frames.forEach(function (f) {
      io.observe(f);
    });
  }
  initReels();
  document.addEventListener('shopify:section:load', initReels);

  /* Filters re-render the grid: hook load more again */
  document.addEventListener('shopify:section:load', init);
  var gridHost = document.getElementById('ProductGridContainer');
  if (gridHost) {
    new MutationObserver(function () {
      initLoadMore(gridHost.parentElement || document);
    }).observe(gridHost, { childList: true, subtree: false });
  }
})();
